import { BrowserRouter, Route, Routes } from "react-router-dom";
import "azure-maps-control/dist/atlas.min.css";
import "mapbox-gl/dist/mapbox-gl.css";
import NavPanel from "./component/navigation/NavPanel";
import HomePage from "./component/pages/HomePage";
import TransmissionInsightsPage from "./component/pages/TransmissionInsightsPage";
import BlogPage from "./component/pages/BlogPage";
import DashboardPage from "./component/pages/DashboardPage";
import DataPage from "./component/pages/DataPage";
import MarketInsightsPage from "./component/pages/MarketInsightsPage";
import ReferencePage from "./component/pages/ReferencesPage";
import SettingsPage from "./component/pages/SettingsPage";
import SiteMapPage from "./component/pages/SiteMapPage";
import ArticlePage from "./component/pages/ArticlePage";
import { ThemeProvider } from "./contexts/ThemeContext";
import { TransmissionInsightsProvider } from "./contexts/TransmissionInsightsContext";
import { QueueInsightsProvider } from "./contexts/QueueInsightsContext";
import { useState } from "react";
import QueueInsightsPage from "./component/pages/QueueInsightsPage";

function AppContent() {
    const [isNavPanelOpen, setisNavPanelOpen] = useState(false);

    const toggleNavbar = () => {
        setisNavPanelOpen(!isNavPanelOpen);
    };

    return (
        <div className="flex h-[100vh]">
            <NavPanel
                isOpen={isNavPanelOpen}
                onToggle={toggleNavbar}
            />
            <div className="flex-1">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                        path="/blog"
                        element={<BlogPage />}
                    />
                    <Route 
                        path="/blog/:id" 
                        element={
                            <ArticlePage 
                                isPageExpanded={!isNavPanelOpen}
                            />
                        } 
                    />
                    <Route
                        path="/dashboard"
                        element={<DashboardPage />}
                    />
                    <Route
                        path="/queue-insights"
                        element={
                            <QueueInsightsPage
                                isPageExpanded={!isNavPanelOpen}
                            />
                        }
                    />
                    <Route
                        path="/transmission-insights"
                        element={
                            <TransmissionInsightsPage
                                isPageExpanded={!isNavPanelOpen}
                            />
                        }
                    />
                    <Route
                        path="/market-insights"
                        element={<MarketInsightsPage />}
                    />
                    <Route
                        path="/data"
                        element={<DataPage />}
                    />
                    <Route
                        path="/references"
                        element={<ReferencePage />}
                    />
                    <Route
                        path="/settings"
                        element={<SettingsPage />}
                    />
                    <Route
                        path="/site-map"
                        element={<SiteMapPage />}
                    />
                </Routes>
            </div>
        </div>
    );
}

export default function App() {
    return (
        <ThemeProvider>
            <TransmissionInsightsProvider>
                <QueueInsightsProvider>
                    <BrowserRouter>
                        <AppContent />
                    </BrowserRouter>
                </QueueInsightsProvider>
            </TransmissionInsightsProvider>
        </ThemeProvider>
    );
}
